var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import { toYuan } from '../../utils/unit-conversion';
import { rewardStatus } from '../../constant/common-type';
import { exportData } from '../../utils/common-export-polling';
export default Vue.extend({
    name: 'rewardTabel',
    data: function () {
        return {
            date: '',
            userMsg: '',
            userSelect: 'driverName',
            currentType: '',
            currentStatus: '',
            users: [
                {
                    label: '司机姓名',
                    val: 'driverName',
                },
                {
                    label: '司机注册手机号',
                    val: 'driverPhone',
                },
                {
                    label: '合同号',
                    val: 'contractCode',
                },
            ],
            types: [
                {
                    label: '全部',
                    val: '',
                },
                {
                    label: '奖励',
                    val: 'AWARD',
                },
                {
                    label: '补贴',
                    val: 'ALLOWANCE',
                },
                {
                    label: '退款',
                    val: 'REFUND',
                },
            ],
            statusOptions: [
                {
                    label: '全部',
                    val: '',
                },
                {
                    label: '成功',
                    val: 'SUCCESS',
                },
                {
                    label: '处理中',
                    val: 'HANDLING',
                },
                {
                    label: '失败',
                    val: 'FAIL',
                },
            ],
            rewardListData: [],
            pageNo: 1,
            pageSize: 20,
            totalItemCount: 20,
        };
    },
    computed: {
        length: function () {
            return this.rewardListData.length;
        },
        maxHeight: function () {
            return window.innerHeight - 200;
        },
    },
    created: function () {
        this.getData();
    },
    methods: {
        importMain: function () {
            var params = this.getParams();
            exportData({
                keyUrl: '/proxy/api/reward/export',
                statusUrl: '/proxy/api/getFileUrl',
                params: params,
            });
        },
        getParams: function () {
            var _a;
            var _b = this, userSelect = _b.userSelect, userMsg = _b.userMsg, currentType = _b.currentType, date = _b.date, currentStatus = _b.currentStatus;
            var startDate = '';
            var endDate = '';
            if (date instanceof Array && date.length > 0) {
                startDate = moment(date[0]).format('YYYY-MM-DD');
                endDate = moment(date[1]).format('YYYY-MM-DD');
            }
            return _a = {},
                _a[userSelect] = userMsg,
                _a.type = currentType,
                _a.status = currentStatus,
                _a.startDate = startDate,
                _a.endDate = endDate,
                _a;
        },
        getData: function () {
            var _this = this;
            var params = this.getParams();
            var data = Object.assign(__assign({ pageNo: this.pageNo, pageSize: this.pageSize }, params));
            this.$request({
                url: '/proxy/api/reward/page',
                method: 'post',
                data: data,
            }).then(function (res) {
                if (!res || res.errorCode)
                    return;
                var pageNo = res.pageNo, pageSize = res.pageSize, totalItemCount = res.totalItemCount, data = res.data;
                _this.pageNo = pageNo;
                _this.pageSize = pageSize;
                _this.totalItemCount = totalItemCount;
                _this.rewardListData = data;
            });
        },
        sizeChange: function (pageSize) {
            this.pageSize = pageSize;
            this.getData();
        },
        currentChange: function (currentPageNo) {
            this.pageNo = currentPageNo;
            this.getData();
        },
        userSelectMain: function () {
            this.userMsg = '';
        },
        typeFormatter: function (row, column, cellValue, index) {
            var types = {
                AWARD: '奖励',
                ALLOWANCE: '补贴',
                REFUND: '退款',
            };
            return types[cellValue];
        },
        amountFormatter: function (row, column, cellValue, index) {
            return toYuan(cellValue).toFixed(2);
        },
        statusFormatter: function (row) {
            return rewardStatus[row.status];
        },
        remarkFormatter: function (row, column, cellValue, index) {
            return cellValue === '' ? '--' : cellValue;
        },
        cellStyle: function (_a) {
            var row = _a.row, column = _a.column, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
            if (columnIndex === 6) {
                if (row.status === 'FAIL') {
                    return 'color:#FF5257';
                }
                if (row.status === 'HANDLING') {
                    return 'color:#2F86F6';
                }
            }
        },
    },
});
